import { render, staticRenderFns } from "./HeartRate.vue?vue&type=template&id=33de4578&scoped=true&"
import script from "./HeartRate.vue?vue&type=script&lang=js&"
export * from "./HeartRate.vue?vue&type=script&lang=js&"
import style0 from "./HeartRate.vue?vue&type=style&index=0&id=33de4578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de4578",
  null
  
)

export default component.exports